module.exports = __webpack_public_path__ + "static/media/stories.6df68cf4.svg";